export const replaceMultipleForwardSlash = (str: string): string =>
	str.replace(/\/{2,}/g, '/');
